import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'delta',
  initialState: null,
  reducers: {
    getUserDetails: (state, action) => action.payload,
    resetUserDetails: () => null,
  },
});

export const { getUserDetails, resetUserDetails } = userSlice.actions;

export default userSlice.reducer;
